<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap class="ma-0">

      <v-toolbar class="pa-0 ma-0 toolbar-padding" :class="{ 'toolbar-shadow': scrollY === 0 }"
                 color="white" flat dense fixed app>
        <v-btn small flat icon disabled>
          <v-icon size="16px">$vuetify.icons.confirm</v-icon>
        </v-btn>
        <h3 class="display-2" style="margin-bottom: 2px">결제 확인</h3>
      </v-toolbar>

      <v-flex xs12>
        <v-card tile class="my-3 mx-3 pt-4 card-style" v-if="$route.query.status === '00'">
          <v-img class="mt-3 mb-5" style="margin: auto;" width="151px" :src="require('@/assets/img/yuni-congratulations.png')"></v-img>
          <v-divider style="margin-left: 10px; margin-right: 10px; border-style: dashed;"></v-divider>
          <v-card-title style="font-size: 32px; font-weight: 700; letter-spacing: -0.5px; color: #ec2f54;">
            <span style="margin: auto;">구매완료!</span>
          </v-card-title>
        </v-card>

        <v-card tile class="my-3 mx-3 pt-4 card-style" v-else>
          <v-img class="mt-3 mb-5" style="margin: auto;" width="100px" :src="require('@/assets/img/yuni-no-update.png')"></v-img>
          <v-divider style="margin-left: 10px; margin-right: 10px; border-style: dashed;"></v-divider>
          <v-card-title>
            <span style="color: #ec2f54; margin: auto;">구매에 실패하였습니다.</span>
          </v-card-title>
          <v-card-title class="pt-0">
            <span style="font-size: 12px; color: #9b9b9b; margin: auto;">{{ $route.query.status }}: {{ $route.query.msg }}</span>
          </v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-card tile class="my-3 mx-3 py-3 card-style">
          <v-layout row>
            <v-flex xs6>
              <v-btn class="ma-0 display-2" block flat @click="$router.push({ name: 'Store' })">스토어 메인으로</v-btn>
            </v-flex>
            <v-divider></v-divider>
            <v-flex xs6>
              <v-btn class="ma-0 display-2" block flat @click="$router.push({ name: 'Purchases' })">구매목록으로</v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'complete',
    data () {
      return {
        scrollY: 0,
      };
    },
    beforeRouteEnter (to, from, next) {
      if (to.query.status) next();
      else next({
        name: 'Store',
        replace: true,
      });
    },
    created () {
      window.addEventListener('scroll', this.getScrollY);
    },
    destroyed () {
      window.removeEventListener('scroll', this.getScrollY);
    },
    methods: {
      getScrollY () {
        this.scrollY = window.scrollY;
      },
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.toolbar-shadow .v-toolbar__content {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  /deep/.toolbar-padding .v-toolbar__content {
    padding: 0 10px 0 16px;
  }

  .card-style {
    position: relative;
    border-radius: 5px !important;
    box-shadow: 0 10px 10px rgba(#9b9b9b, 0.25) !important;
  }
</style>
